// extracted by mini-css-extract-plugin
module.exports = {"MainContainer":"Layout_MainContainer__2uUki","TitlePageContainer":"Layout_TitlePageContainer__1_s4n","ContentContainer":"Layout_ContentContainer__3kzC4"};